import { DataImportKindEnum, DataImportStatusEnum } from 'graphql-common';
import { ChipTypes } from '@lib/components/Chip/Chip';

export function getDataImportKindOptions() {
  return [
    {
      labelKey: 'sites',
      value: DataImportKindEnum.Site,
      leftIcon: 'home_pin',
    },
    {
      labelKey: 'areas',
      value: DataImportKindEnum.SiteArea,
      leftIcon: 'location_on',
    },
    {
      labelKey: 'assets',
      value: DataImportKindEnum.Asset,
      leftIcon: 'inventory',
    },
  ];
}

export function getDataImportKindOptionsByPermission({
  isSitesAvailable,
  isAssetsAvailable,
}: {
  isSitesAvailable: boolean;
  isAssetsAvailable: boolean;
}) {
  return getDataImportKindOptions().filter(({ value }) => {
    if (isSitesAvailable && value === DataImportKindEnum.Site) return true;
    if (isSitesAvailable && value === DataImportKindEnum.SiteArea) return true;
    if (isAssetsAvailable && value === DataImportKindEnum.Asset) return true;
    return false;
  });
}

export function getDataImportKindOption(value: DataImportKindEnum) {
  return getDataImportKindOptions().find((option) => option.value === value);
}

export function getDataImportStatusChipType(status: DataImportStatusEnum) {
  let type = ChipTypes.chipDisabled;
  if (status === DataImportStatusEnum.Complete) type = ChipTypes.chipGreen;
  if (status === DataImportStatusEnum.Failed) type = ChipTypes.chipRed;
  if (status === DataImportStatusEnum.Interrupted) type = ChipTypes.chipCorral;
  if (status === DataImportStatusEnum.Queued) type = ChipTypes.chipViolet;
  if (status === DataImportStatusEnum.Retrying) type = ChipTypes.chipYellow;
  if (status === DataImportStatusEnum.Stopped) type = ChipTypes.chipBlack;
  if (status === DataImportStatusEnum.Working) type = ChipTypes.chipBlue;
  return type;
}
